/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Domain access permissions of the user
 */
export type PublicUserPermissionAssignmentDto = {
    /**
     * Id of the domain
     */
    domainId: string;
    /**
     * Domain role assigned to the principal for accessing the referenced domain
     */
    domainRole?: PublicUserPermissionAssignmentDto.domainRole;
};

export namespace PublicUserPermissionAssignmentDto {

    /**
     * Domain role assigned to the principal for accessing the referenced domain
     */
    export enum domainRole {
        EDITOR = 'EDITOR',
        MONITOR_RESPONDER = 'MONITOR_RESPONDER',
        CATALOG_EDITOR = 'CATALOG_EDITOR',
        VIEWER = 'VIEWER',
    }


}
